module.exports = __webpack_public_path__ + "img/audit-trail.aef04769.svg";